import { render, staticRenderFns } from "./jgbkd.vue?vue&type=template&id=3195394e&scoped=true"
import script from "./jgbkd.vue?vue&type=script&lang=js"
export * from "./jgbkd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3195394e",
  null
  
)

export default component.exports